import React from "react";
import { Plus } from "lucide-react";
import { Button } from "./Button";

interface EmptyStateProps {
  onAddData?: () => void;
}

export function EmptyState({ onAddData }: EmptyStateProps) {
  return (
    <div className="py-12 px-4 text-center">
      <h2 className="text-xl font-normal font-book-heading text-fg">
        No connected data yet
      </h2>
      <p className="text-sm text-fg2 mt-2 leading-relaxed">
        Add your Cashboard data to this workbook and refresh it with a click.
      </p>
      <div className="mt-4">
        <Button
          variant="primary"
          size="md"
          leadingIcon={<Plus size={16} />}
          label="Add data"
          onClick={onAddData}
        />
      </div>
    </div>
  );
}
